export default "__VITE_ASSET__Bur34tAB__"